import Yup from 'utils/yup'

export const defaultValues = {
  quantity: null,
}

export const validationSchema = Yup.object().shape({
  quantity: Yup.number().nullable().required().min(1, 'Quantidade inválida'),
})
